import { render, staticRenderFns } from "./CarouselGameDateTime.vue?vue&type=template&id=b3841272&scoped=true&"
import script from "./CarouselGameDateTime.vue?vue&type=script&lang=js&"
export * from "./CarouselGameDateTime.vue?vue&type=script&lang=js&"
import style0 from "./CarouselGameDateTime.vue?vue&type=style&index=0&id=b3841272&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3841272",
  null
  
)

export default component.exports